import { createPinia } from 'pinia'
import { createSSRApp } from 'vue'
import App from './App.vue'
import { createAppRouter } from './router'
import './styles/base.css'

export function createApp(url = '/', initialState?: Record<string, unknown>) {
  const app = createSSRApp(App)
  const pinia = createPinia()
  const router = createAppRouter()
  if (initialState) pinia.state.value = initialState as typeof pinia.state.value
  app.use(pinia)
  app.use(router)

  return { app, pinia, router, url }
}
